export function fmtMoney(n, currency = "USD") {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  const abs = Math.abs(Number(n));
  const sign = n < 0 ? "-" : "";
  const symbols = { USD: "$", INR: "₹", EUR: "€" };
  const sym = symbols[currency] || "";
  if (abs >= 1_000_000) return `${sign}${sym}${(abs / 1_000_000).toFixed(2)}M`;
  if (abs >= 1_000) return `${sign}${sym}${(abs / 1_000).toFixed(2)}K`;
  return `${sign}${sym}${abs.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtPrice(n, decimals = 2) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return Number(n).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function fmtPct(n, fixed = 2) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  const v = Number(n).toFixed(fixed);
  return `${v >= 0 ? "+" : ""}${v}%`;
}

export function pctClass(n) {
  if (n > 0) return "text-[#00E676]";
  if (n < 0) return "text-[#FF3B30]";
  return "text-[#8B95A5]";
}

export function timeAgo(iso) {
  if (!iso) return "—";
  const t = new Date(iso).getTime();
  const diff = Date.now() - t;
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}
